import {MODULE_CONTEXT_MENU_DIRECTIONS} from "../../constants";

export const topCabinetModuleSystem = [
  ["18_18_25", "18_18_26"],
  ["18_36_4", "18_36_5"],
  ["36_36_1"],
  ["18_36_4", "18_18_26", "18_18_28"],
  ["18_36_4", "18_36_5"],
  ["18_18_25", "18_18_26"],
  ["18_36_4", "18_36_5"],
  ["36_36_1"]
];

export const bottomCabinetModuleSystem = [
  [],
  ["36_12_41", "36_24_10"],
  ["24_12_44", "12_36_8", "24_12_46", "24_12_48"],
  ["12_36_6", "24_36_3"],
  ["12_36_6", "24_12_45", "24_24_18"],
  ["36_36_1"],
  ["36_12_41", "36_24_10"],
  ["36_12_41", "36_12_42", "36_12_43"]
];

export const getModuleCombinations = (moduleContextMenuModulePart, direction = MODULE_CONTEXT_MENU_DIRECTIONS.Vertical) => {
  // width-height-id
  switch (moduleContextMenuModulePart) {
    case "1":
      switch (direction) {
        case MODULE_CONTEXT_MENU_DIRECTIONS.Vertical:
          return ["12_36_6-12_36_7-12_36_8", "18_36_4-18_36_5", "24_36_2-12_36_8", "12_36_6-24_36_3"];
        case MODULE_CONTEXT_MENU_DIRECTIONS.Horizontal:
          return ["36_12_41-36_12_42-36_12_43", "36_18_19-36_18_20", "36_24_9-36_12_43", "36_12_41-36_24_10"];
        default:
          return []
      }
    case "2":
      switch (direction) {
        case MODULE_CONTEXT_MENU_DIRECTIONS.Vertical:
          return ["12_36_6-12_36_7"];
        case MODULE_CONTEXT_MENU_DIRECTIONS.Horizontal:
          return ["24_24_15-24_12_48", "24_24_17-24_12_44", "24_18_21-24_18_23", "24_12_44-24_12_46-24_12_48"];
        default:
          return []
      }
    case "3":
      switch (direction) {
        case MODULE_CONTEXT_MENU_DIRECTIONS.Vertical:
          return ["12_36_7-12_36_8"];
        case MODULE_CONTEXT_MENU_DIRECTIONS.Horizontal:
          return ["24_24_16-24_12_49", "24_24_18-24_12_45", "24_18_22-24_18_24", "24_12_45-24_12_47-24_12_49"];
        default:
          return []
      }
    case "4":
      return ["18_24_11-18_12_54", "18_24_13-18_12_50", "18_18_25-18_18_27", "18_12_50-18_12_52-18_12_54"];
    case "5":
      return ["18_24_12-18_12_55", "18_24_14-18_12_51", "18_18_26-18_18_28", "18_12_51-18_12_53-18_12_55"];
    case "6": // left 18
      return ["12_18_29-12_18_32", "12_24_35-12_12_62", "12_24_38-12_12_56", "12_12_56-12_12_59-12_12_62"];
    case "7": // center 18
      return ["12_18_30-12_18_33", "12_24_36-12_12_63", "12_24_39-12_12_57", "12_12_57-12_12_60-12_12_63"];
    case "8": // right 18
      return ["12_18_31-12_18_34", "12_24_37-12_12_64", "12_24_40-12_12_58", "12_12_58-12_12_61-12_12_64"];
    case "9":
      switch (direction) {
        case MODULE_CONTEXT_MENU_DIRECTIONS.Vertical:
          return ["18_24_11-18_24_12", "24_24_15-12_24_37", "24_24_16-12_24_35", "12_24_35-12_24_36-12_24_37"];
        case MODULE_CONTEXT_MENU_DIRECTIONS.Horizontal:
          return ["36_12_41-36_12_42"];
        default:
          return []
      }
    case "10":
      switch (direction) {
        case MODULE_CONTEXT_MENU_DIRECTIONS.Vertical:
          return ["18_24_13-18_24_14", "24_24_17-12_24_40", "24_24_18-12_24_38", "12_24_38-12_24_39-12_24_40"];
        case MODULE_CONTEXT_MENU_DIRECTIONS.Horizontal:
          return ["36_12_42-36_12_43"];
        default:
          return []
      }
    case "11":
      return ["18_12_50-18_12_52"];
    case "12":
      return ["18_12_51-18_12_53"];
    case "13":
      return ["18_12_52-18_12_54"];
    case "14":
      return ["18_12_53-18_12_55"];
    case "15":
      return ["12_24_35-12_24_36", "24_12_44-24_12_46"];
    case "16":
      return ["12_24_36-12_24_37", "24_12_45-24_12_47"];
    case "17":
      return ["12_24_38-12_24_39", "24_12_46-24_12_48"];
    case "18":
      return ["12_24_39-12_24_40", "24_12_47-24_12_49"];
    case "19":
      return ["24_18_21-12_18_31", "24_18_22-12_18_29", "18_18_25-18_18_26", "12_18_29-12_18_30-12_18_31"];
    case "20":
      return ["24_18_23-12_18_34", "24_18_24-12_18_32", "18_18_27-18_18_28", "12_18_32-12_18_33-12_18_34"];
    case "21":
      return ["12_18_29-12_18_30"];
    case "22":
      return ["12_18_30-12_18_31"];
    case "23":
      return ["12_18_32-12_18_33"];
    case "24":
      return ["12_18_33-12_18_34"];
    case "35":
      return ["12_12_56-12_12_59"];
    case "36":
      return ["12_12_57-12_12_60"];
    case "37":
      return ["12_12_58-12_12_61"];
    case "38":
      return ["12_12_59-12_12_62"];
    case "39":
      return ["12_12_60-12_12_63"];
    case "40":
      return ["12_12_61-12_12_64"];
    case "41":
      return ["24_12_44-12_12_58", "24_12_45-12_12_56", "12_12_56-12_12_57-12_12_58"];
    case "42":
      return ["24_12_46-12_12_61", "24_12_47-12_12_59", "12_12_59-12_12_60-12_12_61"];
    case "43":
      return ["24_12_48-12_12_64", "24_12_49-12_12_62", "12_12_62-12_12_63-12_12_64"];
    case "44":
      return ["12_12_56-12_12_57"];
    case "45":
      return ["12_12_57-12_12_58"];
    case "46":
      return ["12_12_59-12_12_60"];
    case "47":
      return ["12_12_60-12_12_61"];
    case "48":
      return ["12_12_62-12_12_63"];
    case "49":
      return ["12_12_63-12_12_64"];
    case "50":
    case "51":
    case "52":
    case "53":
    case "54":
    case "55":
    case "56":
    case "57":
    case "58":
    case "59":
    case "60":
    case "61":
    case "62":
    case "63":
    case "64":  // no where to split more!
    default:
      return []
  }
};